'use client'
import { Text } from '../../atoms'
import { TextTypes } from '../../../types'
import React from 'react'

export interface FormHelpTextProps {
    children: React.ReactNode
}

export const FormHelpText = ({ children }: FormHelpTextProps) => <Text type={TextTypes.SMALL_TEXT}>{children}</Text>
